import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Monitor, Smartphone } from "lucide-react";

interface EmailPreviewProps {
  subject: string;
  htmlContent: string;
  onClose: () => void;
}

export const EmailPreview = ({ subject, htmlContent, onClose }: EmailPreviewProps) => {
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>Email Preview</DialogTitle>
          <p className="text-sm text-muted-foreground">Subject: {subject}</p>
        </DialogHeader>
        
        <Tabs defaultValue="desktop" className="flex-1 flex flex-col">
          <TabsList className="grid w-fit grid-cols-2">
            <TabsTrigger value="desktop" className="flex items-center gap-2">
              <Monitor className="h-4 w-4" />
              Desktop
            </TabsTrigger>
            <TabsTrigger value="mobile" className="flex items-center gap-2">
              <Smartphone className="h-4 w-4" />
              Mobile
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="desktop" className="flex-1 mt-4">
            <div className="border rounded-lg h-full overflow-auto bg-gray-50 p-4">
              <div className="max-w-2xl mx-auto bg-white shadow-sm">
                <iframe
                  srcDoc={htmlContent}
                  className="w-full h-full min-h-[500px] border-0"
                  title="Email Preview Desktop"
                />
              </div>
            </div>
          </TabsContent>
          
          <TabsContent value="mobile" className="flex-1 mt-4">
            <div className="border rounded-lg h-full overflow-auto bg-gray-50 p-4 flex justify-center">
              <div className="w-80 bg-white shadow-sm">
                <iframe
                  srcDoc={htmlContent}
                  className="w-full h-full min-h-[500px] border-0"
                  title="Email Preview Mobile"
                />
              </div>
            </div>
          </TabsContent>
        </Tabs>
        
        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" onClick={onClose}>
            Close Preview
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};